const storedSessionId = localStorage.getItem("sessionId");

export const initialState = {
  user: storedSessionId ? { sessionId: storedSessionId } : null,
  company: null,
  companyError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_LOADED":
      return {
        ...state,
        user: action.payload,
      };
    case "COMPANY_LOADED":
      return {
        ...state,
        company: action.payload,
        companyError: null,
      };
    case "COMPANY_LOAD_FAILED":
      return {
        ...state,
        company: null,
        companyError: action.payload ?? "",
      };
    default:
      return state;
  }
};
